import probateImage from "@/shared/assets/login/probate.jpg";
import assetSearchImage from "@/shared/assets/login/asset-search.jpg";
import estateExpertImage from "@/shared/assets/login/estate-expert.jpg";

import type { Story } from "./components/StoryCarousel";

const ALL_STORIES: Record<string, Story> = {
  probate: {
    id: "probate",
    image: probateImage,
    title: "Get probate-ready with confidence",
    description:
      "Find out where the estate stands, if you need an attorney, and what to gather before you start",
  },
  "asset-search": {
    id: "asset-search",
    image: assetSearchImage,
    title: "Over $5M found with Elayne Asset Search",
    description:
      "Find bank accounts, insurance policies, retirement accounts, and other assets that might otherwise go undiscovered.",
  },
  "estate-expert": {
    id: "estate-expert",
    image: estateExpertImage,
    title: "Talk to someone who's guided over 1,000 families through this",
    description:
      "When questions come up, your Estate Expert answers them one-on-one, so you're never guessing",
  },
};

const STORY_ORDERS: Record<string, string[]> = {
  default: ["probate", "asset-search", "estate-expert"],
  probate: ["probate", "asset-search", "estate-expert"],
  "asset-search": ["asset-search", "estate-expert", "probate"],
  "estate-expert": ["estate-expert", "probate", "asset-search"],
};

export function getOrderedStories(storyParam: string | null): Story[] {
  const key = storyParam && storyParam in STORY_ORDERS ? storyParam : "default";
  return STORY_ORDERS[key].map((id) => ALL_STORIES[id]);
}
